import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import getProductQuantity from '../selector/getProductQuantity';
import getLastOrderItemId from '../selector/getLastOrderItemId';

const updateProductQuantityOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const quantity = getProductQuantity(store);
    const orderItemId = getLastOrderItemId(store);

    return apiRequest(
      endpoints.cartV1ItemQuantityUpdate,
      {
        quantity,
        orderItemId,
      },
      HttpMethods.POST,
      'data',
    );
  };

export default updateProductQuantityOperation;
